// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__KPcfk","radioRow":"SimpleQuestionBuilderModal_radioRow__2KC1r"};